import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";

const initialState = {
    likedCruises:  [],
    archiveTooltip: false,
    rebrandingPopup: false,
    status: "idle",
};

// The function below is called a thunk and allows us to perform async logic. It
// can be dispatched like a regular action: `dispatch(incrementAsync(10))`. This
// will call the thunk with the `dispatch` function as the first argument. Async
// code can then be executed and other actions can be dispatched. Thunks are
// typically used to make async requests.
export const incrementAsync = createAsyncThunk("likedCruises/fetchCount", async (amount) => {
    // The value we return becomes the `fulfilled` action payload
});

export const likedCruisesSlice = createSlice({
    name: "likedCruises",
    initialState,
    // The `reducers` field lets us define reducers and generate associated actions
    reducers: {
        toggleLikedUnlikedCruisesData: (state, action) => {
            const cruise = action.payload;
            const exists = state.likedCruises.some(c => c == cruise);

            if (exists) {
                state.likedCruises = state.likedCruises.filter(c => c != cruise);
            } else {
                state.likedCruises.push(cruise);
            }
        },
        addToLikedCruises: (state, action) => {
            const cruise = action.payload;
            const exists = state.likedCruises.some(c => c == cruise);

            if(exists){
                return
            }
            state.likedCruises.push(cruise);
        },
        toggleArchiveTooltip: (state, action) => {
            state.archiveTooltip = action.payload
        },
        updateRebrandingPopup: (state, action) => {
            state.rebrandingPopup = action.payload
        },
    },
    // The `extraReducers` field lets the slice handle actions defined elsewhere,
    // including actions generated by createAsyncThunk or in other slices.
    extraReducers: (builder) => {},
});

export const { toggleLikedUnlikedCruisesData, addToLikedCruises, toggleArchiveTooltip, updateRebrandingPopup } = likedCruisesSlice.actions;

// The function below is called a selector and allows us to select a value from
// the state. Selectors can also be defined inline where they're used instead of
// in the slice file. For example: `useSelector((state: RootState) => state.likedCruises.value)`
export const selectLikedCruises = (state) => state.likedCruises;
export const selectArchiveTooltip = (state) => state.likedCruises;
export const selectRebrandingPopupState = (state) => state.likedCruises.rebrandingPopup;

export default likedCruisesSlice.reducer;
